/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Errata_DescriptionInputs */



/**
* | output |
* | --- |
* | "Every official card wording change" |
*
* @param {Nav_Errata_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_errata_description = /** @type {((inputs?: Nav_Errata_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Errata_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle offiziellen Wortlautänderungen an Karten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les modifications officielles du texte des cartes")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("官方卡牌文字修改一览")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("官方卡牌文字修改一覽")
	if (locale === "ko") return /** @type {LocalizedString} */ ("공식 카드 문구 변경 모음")
	return /** @type {LocalizedString} */ ("Every official card wording change")
});